import {PostList} from '../../Data/Post';

const AddListsIntoFilters = (filters, lists) => {

    let returnFilters = [];
   
    if (filters !== undefined && Array.isArray(filters)) {
        for (const filter of filters) {
            returnFilters.push({...filter});
        }
        for (const filter of returnFilters) {
            if (filter.OptionsName !== undefined) {
                const list = lists.filter(l => l.Name.toLowerCase() === filter.OptionsName.toLowerCase());
                if (list.length > 0) {
                    filter.Options = list[0].Options.map((option) => { return {key: option.Key, text: option.Text}});
                }
            }
        } 
    }

    return returnFilters;
}

const AddDynamicFilterList = (filters, lists) => {

    var dynamicFilters = filters.filter(f => f.Dynamic);
    for (const filter of dynamicFilters) {
        if (filter.OptionsName !== undefined) {
            const list = lists.filter(l => l.name.toLowerCase() === filter.OptionsName.toLowerCase());
            filter.Options = list[0].options.map((option) => { return {key: option.key, text: option.text}});
        }
    }
    return dynamicFilters;
}

const DoesFilterContainDynamicList = (filters) => {
    var dynamicFilters = filters.filter(f => f.Dynamic);
    return dynamicFilters.length > 0;
}

const GetDynamicListsFromDatabase = (state, retrievedHandler, errorWhenRetrievingData ) => {
    let dynamicLists = [];
    
    if (DoesFilterContainDynamicList(state.filters)) {

        var dynamicFilters = state.filters.filter(f => f.Dynamic);
        for (const filter of dynamicFilters) {
            //dynamicLists = dynamicLists === "" ? filter.OptionsName : dynamicLists + "," + filter.OptionsName;
            dynamicLists.push({name: filter.OptionsName, includeFixed: filter.IncludeFixed === undefined ? true : filter.IncludeFixed});
        }
        PostList(dynamicLists, retrievedHandler, errorWhenRetrievingData, {...state});
    }
}

export default AddListsIntoFilters;
export { AddDynamicFilterList,DoesFilterContainDynamicList,GetDynamicListsFromDatabase }